// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"Sj","categoryName":"Tj","categoryImage":"Uj","categoryContent":"Vj","bottomAligned":"Wj"};